<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    const dispatch = createEventDispatcher()
    import Fa from 'svelte-fa'
    import { faSave } from '@fortawesome/free-solid-svg-icons'
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'
    dayjs.extend(utc)
    import Content from '../../_common/content.svelte'
    import { CompaniesRepository } from '../../../modules/usersApi/companies/companies.repository'
    import { CompaniesService } from '../../../modules/usersApi/companies/companies.service'
    import { Company } from '../../../modules/usersApi/companies/company'
    import type { CompanyCreateDto } from '../../../modules/usersApi/companies/dto/company-create.dto'
    // ##############################################################################################################

    let step = 1
    const rep = new CompaniesRepository()
    const service = new CompaniesService(rep)
    const timezones = service.getTimezones()

    let show = false
    export let company: Company = new Company()

    async function createEntity() {
        try {
            show = true
            const dto: CompanyCreateDto = {
                companyName: company.companyName,
                email: company.email,
                timezone: company.timezone,
            }
            if (!dto.companyName || !dto.email || !dto.timezone) {
                window.error('Todos os campos devem ser preenchidos')
                return
            }
            if (!dto.email.includes('@')) {
                window.error('Informe um e-mail válido')
                return
            }
            company = await service.create(dto)
            sendClose()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function sendClose() {
        dispatch('close', company)
    }

    function getUser() {
        let contact = window.store.user.phone
        if (contact) contact = window.api.utils.utils.phoneFriendly(contact)
        if (!contact) contact = window.store.user.email
        let user = (window.store.user?.userName || '') + ' (' + contact + ')'
        return user
    }

    async function goLogout() {
        await window.api.users.auth.logout(false)
        location.href = '/login'
    }
</script>

{#if company}
    <Content>
        <div class="grid-form">
            {#if step === 1}
                <div class="row">
                    <div class="col cw">
                        <div class="title">Bem vindo ao Zandu</div>
                        <p>O usuário <b>{getUser()}</b> ainda não possui uma empresa no Zandu.</p>
                        <p>Gostaria de criar uma nova empresa?</p>
                        <div class="cw-act mt-2">
                            <button on:click={() => (step = 2)} class="btn btn-primary">Sim, criar uma empresa</button>
                            <button on:click={goLogout} class="btn btn-link">Quero entrar com outro usuário</button>
                        </div>
                    </div>
                </div>
            {/if}
            {#if step === 2}
                <div class="row">
                    <div class="col-md-12">
                        <div class="input-group">
                            <label for="" class="input-group-text">Nome da empresa</label>
                            <input type="text" bind:value={company.companyName} class="form-control" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="input-group">
                            <label for="" class="input-group-text">E-mail da empresa</label>
                            <input type="text" bind:value={company.email} class="form-control" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="input-group">
                            <label for="" class="input-group-text">Fuso horário</label>
                            <select class="form-select" name="" id="" bind:value={company.timezone}>
                                <option value="" />
                                {#each timezones as tz}
                                    <option value={tz.value}>{tz.label}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-end">
                        <button class="btn btn-primary" on:click={createEntity}><Fa icon={faSave} /> Salvar</button>
                    </div>
                </div>
            {/if}
        </div>
    </Content>
{/if}

<style>
    .row {
        padding: 0px 16px;
    }

    .cw .title {
        font-size: 22px;
        margin-top: 16px;
        margin-bottom: 16px;
    }
    .cw-act {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 16px;
    }
</style>
